import React from 'react';
import { formatTextFloat, formatValueBillion } from '../../../../helpers/Text';
import './popup.scss';
import { Translate } from 'react-redux-i18n';
import ScrollComponent from '../../../../common/ScrollComponent';
import PropTypes from 'prop-types';
import Const from '../../Const';

class PopupMultiple extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      average: null,
      isSelectAll: false,
      listDataCheckbox: [],
    };
  }

  formatValueAverage = value => {
    return formatTextFloat(value).slice(0, 5);
  };

  calculatePE = (total, totalCheckBox) => {
    return total / totalCheckBox;
  };

  isAllCheckboxHasSelected = listDataCheckbox => {
    let isCheckedAll = true;
    listDataCheckbox.map(item => {
      if (item.isCheck === false) {
        isCheckedAll = false;
      }
    });
    return isCheckedAll;
  };

  handleUncheckAllTextbox = listDataCheckbox => {
    listDataCheckbox.forEach(item => {
      item.isCheck = false;
    });
    this.setState({
      isSelectAll: false,
      average: null,
      listDataCheckbox,
    });
  };

  selectAllCheckBox = () => {
    const { type } = this.props;
    let listDataCheckbox = this.state.listDataCheckbox;
    const totalCheckBox = listDataCheckbox.length;
    let total = 0;

    if (!this.state.isSelectAll) {
      if (this.isAllCheckboxHasSelected(listDataCheckbox)) {
        this.handleUncheckAllTextbox(listDataCheckbox);
      } else {
        listDataCheckbox.forEach(item => {
          item.isCheck = true;
          if (type === Const.typePopUp.peMultiple) {
            total += item.pe;
          } else {
            total += item.pb;
          }
        });

        this.setState({
          isSelectAll: !this.state.isSelectAll,
          listDataCheckbox,
          average: this.formatValueAverage(
            this.calculatePE(total, totalCheckBox),
          ),
        });
      }
    } else {
      this.handleUncheckAllTextbox(listDataCheckbox);
    }
  };

  selectCheckBox = itemCheckbox => () => {
    const { type } = this.props;
    let arrayCheckedValueCheckbox = this.state.listDataCheckbox;
    arrayCheckedValueCheckbox.forEach(item => {
      if (item.organCode === itemCheckbox.organCode) {
        item.isCheck = !item.isCheck;
      }
    });

    let total = 0;
    let totalCheckBox = 0;
    arrayCheckedValueCheckbox.forEach(item => {
      if (item.isCheck) {
        totalCheckBox += 1;
        if (type === Const.typePopUp.peMultiple) {
          total += item.pe;
        } else {
          total += item.pb;
        }
      }
    });

    this.setState({
      average: this.formatValueAverage(this.calculatePE(total, totalCheckBox)),
      listDataCheckbox: arrayCheckedValueCheckbox,
      isSelectAll: false,
    });
  };

  formatListInfoCheckbox = (listInfoCheckbox = []) => {
    const { listTickerDefault } = this.props;
    listTickerDefault.forEach(item => {
      listInfoCheckbox.find(itemDefault => {
        if (item.code === itemDefault.organCode) {
          itemDefault.ticker = item.displayCode;
        }
      });
    });
    return listInfoCheckbox;
  };

  componentDidMount() {
    const { listInfoCheckbox } = this.props;
    let formatListInfoCheckbox = this.formatListInfoCheckbox(listInfoCheckbox);
    let listDataCheckbox = [];
    formatListInfoCheckbox.forEach(item => {
      item.isCheck = false;
      listDataCheckbox.push(item);
    });
    this.setState({ listDataCheckbox });
  }

  handleClickDone = () => {
    const { finishCaculate, type } = this.props;
    const { average } = this.state;
    finishCaculate(average, type);
  };

  renderCellTable = (width, text, isI18n = false, isBody = false) => {
    const colorValue = +text < 0 ? `text-s-color-3` : `text-s-color-1`;
    if (isBody) {
      return (
        <div className={`column-align-right`} style={{ width }}>
          {isI18n ? <Translate value={text} /> : text}
        </div>
      );
    } else {
      return (
        <div className={`children-div-body ${colorValue}`} style={{ width }}>
          {isI18n ? <Translate value={text} /> : text}
        </div>
      );
    }
  };

  renderCellCheckbox = (item, checkAll = false) => {
    return (
      <div
        className="checkbox wrap-checkbox-first-column-body"
        style={{ width: '30%' }}
      >
        <input
          style={{ position: 'absolute', top: 0 }}
          id={checkAll ? 'check' : item.ticker}
          type="checkbox"
          checked={checkAll ? this.state.isSelectAll : item.isCheck}
          onChange={
            checkAll ? this.selectAllCheckBox : this.selectCheckBox(item)
          }
        />
        <label htmlFor={checkAll ? 'check' : item.ticker}>
          <span className="text-white">
            {checkAll ? (
              <Translate value="valuation.popupPE.selectAll" />
            ) : (
              item.ticker
            )}
          </span>
        </label>
      </div>
    );
  };

  renderBodyTable = () => {
    const { listDataCheckbox } = this.state;
    const { type } = this.props;

    return listDataCheckbox.map(item => {
      return (
        <div className="body-popup-valuation" key={item.organCode}>
          {this.renderCellCheckbox(item)}
          {this.renderCellTable(
            '30%',
            formatTextFloat(formatValueBillion(item.totalAsset)),
          )}
          {this.renderCellTable(
            '15%',
            formatTextFloat(formatValueBillion(item.revenue)),
          )}
          {this.renderCellTable(
            '15%',
            formatTextFloat(formatValueBillion(item.netProfit)),
          )}
          {this.renderCellTable(
            '20%',
            formatTextFloat(formatValueBillion(item.marketCap)),
          )}
          {type === Const.typePopUp.peMultiple
            ? this.renderCellTable('10%', formatTextFloat(item.pe))
            : this.renderCellTable('10%', formatTextFloat(item.pb))}
        </div>
      );
    });
  };

  renderHeaderTable = () => {
    const { type } = this.props;
    return (
      <div className="popup-header-valuation-tool">
        {this.renderCellCheckbox(null, true)}
        {this.renderCellTable(
          '30%',
          'valuation.popupPE.totalAsset',
          true,
          true,
        )}
        {this.renderCellTable('15%', 'valuation.popupPE.rev', true, true)}
        {this.renderCellTable('15%', 'valuation.popupPE.netProfit', true, true)}
        {this.renderCellTable('20%', 'valuation.popupPE.marketCap', true, true)}
        {type === Const.typePopUp.peMultiple
          ? this.renderCellTable('10%', 'valuation.popupPE.pe', true, true)
          : this.renderCellTable('10%', 'valuation.popupPE.pb', true, true)}
      </div>
    );
  };

  renderFooterTable = () => {
    const { average } = this.state;
    const { type } = this.props;

    return (
      <div className="footer-average-pe">
        <a style={{ float: 'left', marginLeft: 10 }}>
          <Translate
            value={
              type === Const.typePopUp.peMultiple
                ? `valuation.popupPE.averagePE`
                : `valuation.popupPE.averagePB`
            }
          />
        </a>
        <a style={{ float: 'right', marginRight: 10 }}>{average}</a>
      </div>
    );
  };

  renderWrapTitleButtonPopup = () => {
    return (
      <div className="popup-title-valuation-tool" style={{ clear: 'both' }}>
        <a style={{ float: 'left', marginTop: 5, fontWeight: 600 }}>
          <Translate value="valuation.popupPE.title" />
        </a>
        <button
          className="popup-button-valuation-tool"
          style={{ float: 'right', marginTop: 5, marginRight: 5 }}
          onClick={this.handleClickDone}
        >
          <Translate value="valuation.popupPE.button" />
        </button>
      </div>
    );
  };

  render() {
    const { isChangePositionPopup } = this.props;
    let styleDivTootip = {};
    if (isChangePositionPopup) {
      styleDivTootip = {
        display: 'block',
        marginTop: -15,
        marginLeft: 20,
        top: -120,
      };
    } else {
      styleDivTootip = {
        display: 'block',
        marginTop: -15,
        marginLeft: 20,
      };
    }

    return (
      <div>
        <div className={`popup-valuation-tool`} style={styleDivTootip}>
          {this.renderWrapTitleButtonPopup()}
          {this.renderHeaderTable()}

          <ScrollComponent appendStyle={{ maxHeight: 80 }}>
            {this.renderBodyTable()}
          </ScrollComponent>

          {this.renderFooterTable()}
        </div>
      </div>
    );
  }
}

PopupMultiple.propTypes = {
  type: PropTypes.string,
};

PopupMultiple.defaultProps = {
  type: Const.typePopUp.peMultiple,
};

export default PopupMultiple;
